import { Box } from '@mui/material';

import { useDiagramEditing } from '../../contexts/diagramEditing.context';

/** Announces the layout progress and a layout failure. */
export function DiagramLayoutStatus() {
  const { reactFlowDiagram } = useDiagramEditing();
  return (
    <Box
      role="status"
      sx={{
        '&:not(:empty)': {
          p: 1,
          fontSize: 12,
        },
      }}
    >
      {reactFlowDiagram.didFail && (
        <>
          Layout failed. Your draft is unchanged.{' '}
          <button onClick={reactFlowDiagram.retryLayout}>Retry layout</button>
        </>
      )}
      {reactFlowDiagram.isArranging && 'Arranging tiles…'}
    </Box>
  );
}
